
import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

interface FeatureItem {
  text: string;
}

interface CoachingLocationCardProps {
  title: string;
  description: string;
  imageUrl: string;
  imageAlt: string;
  features: FeatureItem[];
  ctaText: string;
  ctaLink: string;
}

const CoachingLocationCard: React.FC<CoachingLocationCardProps> = ({
  title,
  description,
  imageUrl,
  imageAlt,
  features,
  ctaText,
  ctaLink,
}) => {
  return (
    <div className="relative rounded-2xl overflow-hidden shadow-soft animate-fade-in">
      <div className="absolute inset-0 z-0">
        <img 
          src={imageUrl} 
          alt={imageAlt} 
          className="w-full h-full object-cover"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0 bg-joerg-800/30 backdrop-blur-[2px]"></div>
      </div>
      
      <div className="relative z-10 p-8">
        <h3 className="text-2xl font-semibold text-white">{title}</h3>
        <p className="mt-4 text-white/95 bg-joerg-800/40 p-2 rounded backdrop-blur-sm inline-block">
          {description}
        </p>
        <div className="mt-6 space-y-3">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start gap-3">
              <Check className="h-5 w-5 text-green-300 flex-shrink-0 mt-0.5 bg-joerg-800/40 p-0.5 rounded-full" />
              <span className="text-white/95 bg-joerg-800/40 p-1 rounded">
                {feature.text}
              </span>
            </div>
          ))}
        </div>
        <div className="mt-6">
          <Link 
            to={ctaLink} 
            className="bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-full inline-flex items-center font-medium transition-colors"
          >
            {ctaText}
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CoachingLocationCard;
